import { Injectable } from '@angular/core';
import { FiltroPerfil, Perfil } from 'src/app/@shared/models/perfil.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ModuloSistema, RequisicaoVinculoPerfilModulo } from 'src/app/@shared/models/modulos-sistema.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private http: HttpClient) { }

  public getPerfis(filtro: FiltroPerfil): Observable<Perfil[]> {
    return this.http.post<Perfil[]>(
      `PerfilAcesso/ListarPerfilAcesso`,
      filtro, httpOptions
    );
  }

  public insertPerfil(perfil: Perfil): Observable<Perfil[]> {
    return this.http.post<Perfil[]>(
      `PerfilAcesso/InserirPerfilAcesso`,
      perfil, httpOptions
    );
  }

  public editPerfil(perfil: Perfil): Observable<Perfil[]> {
    return this.http.put<Perfil[]>(
      `PerfilAcesso/AtualizarPerfilAcesso`,
      perfil, httpOptions
    );
  }

  public deletePerfil(perfil: Perfil, reposicao?: Perfil): Observable<Perfil[]> {
    return this.http.delete<Perfil[]>(
      `PerfilAcesso/ExcluirPerfilAcesso/${perfil.perfilAcessoId}`
      + `?${reposicao && reposicao.perfilAcessoId ?
        'perfilAcessoIdNovo=' + reposicao.perfilAcessoId
        : ''}`, httpOptions
    );
  }

  selecionarEstruturaPerfilAcesso(perfilAcessoId?: number): Observable<ModuloSistema[]> {
    return this.http.get<ModuloSistema[]>(
      `PerfilAcesso/SelecionarEstruturaPerfilAcesso${perfilAcessoId ? `?perfilAcessoId=${perfilAcessoId}` : ''}`,
      httpOptions
    );
  }

  inserirEstruturaPerfilAcessoModulo(req: RequisicaoVinculoPerfilModulo): Observable<any> {
    return this.http.post<any>(
      `PerfilAcesso/InserirEstruturaPerfilAcessoModulo`,
      req, httpOptions
    );
  }

  verificaSePerfilAcessoPossuiVinculoComModulo(perfilAcessoId: number): Observable<any> {
    return this.http.get<any>(
      `PerfilAcesso/VerificaSePerfilAcessoPossuiVinculoComModulo/${perfilAcessoId}`, httpOptions
    );

  };

  alterarBaseOrigem(baseOrigemId: number, modulos: number[]): Observable<any> {
    return this.http.post<any>(
      `PerfilAcesso/AlterarBaseOrigemModulos/${baseOrigemId}`, modulos, httpOptions
    );
  }
}
